import type { RenderedView } from '../router.js';
import { navigate } from '../router.js';
import { brandHero } from '../brand.js';
import { onClick } from '../dom.js';
import { icon } from '../icons.js';
import { repos } from '../store.js';

export async function aboutView(): Promise<RenderedView> {
  const settings = await repos.getSettings();
  const set = !!settings.schoolName || !!settings.teacherName;

  return {
    title: 'About',
    back: '/',
    mount(root) {
      onClick(root, '[data-settings]', () => navigate('#/settings'));
    },
    html: `<div class="view">
      ${brandHero()}
      <div class="card"><p style="margin:0">A standalone, offline-first app for grading multiple-choice answer sheets straight from a phone camera — a self-contained tool for DepEd teachers. All data stays on your device.</p></div>
      <p class="section-label">School &amp; teacher</p>
      <div class="card"><div class="stack">
        <div class="muted" style="font-size:14px">${set
          ? `${settings.schoolName || 'School not set'}${settings.teacherName ? ` · ${settings.teacherName}` : ''}`
          : 'Not set — printed reports will have blank header and signature lines.'}</div>
        <button class="btn ${set ? 'btn-ghost' : 'btn-primary'} btn-block" data-settings>${icon.edit()} ${set ? 'Edit details' : 'Add school &amp; teacher details'}</button>
      </div></div>
      <p class="section-label">About the developer</p>
      <div class="card"><div class="stack">
        <div><strong>Sunny Jay P. Sabuero</strong></div>
        <div class="muted">Teacher V — San Miguel National High School</div>
        <div class="muted">Division of Bukidnon</div>
        <div><a class="link" href="https://about.me/sunnysabuero" target="_blank" rel="noopener noreferrer">about.me/sunnysabuero</a></div>
      </div></div>
    </div>`,
  };
}
